import { useQuery } from "react-query";

import { searchService } from "services";

type UseTerminalSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useTerminalSearchQuery = ({
	pattern,
	page,
	options,
}: UseTerminalSearchQueryProps) =>
	useQuery(
		["terminalSearch", pattern, page],
		() =>
			searchService.getTerminals({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useTerminalSearchQuery;
